"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputValueLength = void 0;
function getInputValueLength(value) {
    if (value === undefined || value === null) {
        return 0;
    }
    return typeof value === 'string' ? value.length : value.toString().length;
}
exports.getInputValueLength = getInputValueLength;
